<template>
    <v-snackbar v-model="show" :color="color" bottom :timeout="2000">
        <v-icon dark class="mr-2">{{ icon }}</v-icon>
        {{ message }}
        <v-spacer></v-spacer>
        <v-btn dark text @click="show = false">
            <v-icon>close</v-icon>
        </v-btn>
    </v-snackbar>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            icon: "",
            message: "",
            color: ""
        };
    },
    computed: {
        snackbar: function() {
            return this.$store.state.snackbar.snackbar;
        }
    },
    watch: {
        snackbar(val) {
            if (val) {
                this.message = val.message;
                this.color = val.color;

                if (this.color == "success") {
                    this.icon = "check_circle";
                } else if (this.color == "error") {
                    this.icon = "warning";
                } else {
                    this.icon = "info";
                }

                this.show = true;
            }
        }
    }
};
</script>